import { Header } from '@/scopes/common/components/Header'
import { mqMin, tok, tokPx } from '@sunwebgroup/ui-components'
import { Breadcrumbs, Typography } from '@sunwebgroup/ui-components/uds'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import styled from 'styled-components'

const queryClient = new QueryClient()

const Wrapper = styled.div`
  background-color: ${tok('semantics_backgrounds_tinted_background_color')};
  min-height: 100vh;
  padding: 0;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding: 0 ${tokPx('primitives_space_32')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding: 0 ${tokPx('primitives_space_48')};
  }
`

const Title = styled(Typography)`
  margin: ${tokPx('primitives_space_16')} 0;
  padding-left: 16px;

  @media ${mqMin('primitives_breakpoint_m_min')} {
    ${Typography.modVariant('display-f-regular')};
    margin: ${tokPx('primitives_space_24')} 0;
    padding-left: 0;
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    ${Typography.modVariant('display-e-regular')};
  }
`

const Content = styled.div`
  align-items: start;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  padding-top: ${tokPx('primitives_space_16')};
  max-width: ${tokPx('primitives_area_size_1440')};

  @media ${mqMin('primitives_breakpoint_m_min')} {
    padding-top: ${tokPx('primitives_space_24')};
  }

  @media ${mqMin('primitives_breakpoint_l_min')} {
    padding-top: ${tokPx('primitives_space_32')};
  }
`

const UserProfileInfoContainer = styled.div`
  background-color: ${tok('semantics_backgrounds_background_color')};
  padding: ${tokPx('primitives_space_20')};
  border-radius: ${tokPx('semantics_boxes_corner_radius')};
  width: 100%;
`

export function UserProfile() {
  return (
    <QueryClientProvider client={queryClient}>
      <Header />
      <Wrapper>
        <Content>
          <Breadcrumbs items={
            [
              { id: 'home', label: 'Home', href: '/' },
              { id: 'account', label: 'Account', href: '/account' },
              { id: 'user-profile', label: 'User Profile' },
            ]
          }
          />
          <Title as="h1" $variant="display-g-regular">User Profile</Title>
          <UserProfileInfoContainer />
        </Content>
      </Wrapper>
    </QueryClientProvider>
  )
}
